import { createSlice } from '@reduxjs/toolkit'

const initialQuestionState = {
  question_english: '',
  question_hindi: '',
  predic_start_time: null,
  predic_end_time: null,
  admin_commission: 15,
  pred_confirm: false,
  pred_autocreate: false,
  slots_per_user: 1000000,
  option:[{ id: 1, option: "YES", isCorrect: false }, { id: 2, option: "NO", isCorrect: false }],
  is_global_trade: false,
  interval: 0.5,
  slot_count: 10,
  is_for_others:false,
  partial_refund_value: 0,
  book_profit: true,
  home_screen: false,
  holdMatching: false,
  joinSlotHold: 10,
  optionForHold: 1,
  question_type:"MATCH",
  isSession: false,
  session_variable: "",
  optionForHold: 1,
  shown_on_mobile: 0,
  trending_question: false,
  is_sold_amount_back:0
};

export const opinionTradingSlice = createSlice({
  name: 'opinionTrading',
  initialState: {
    question: [],
    modal_show: false,
    questionStates: initialQuestionState,
    isSubjective: false,
    isEdit:false,
    isAdd: false,
    isSession:false
  },
  reducers: {
    stateRefresh: (state, action) => {
      state.questionStates = initialQuestionState
      state.isEdit =false
      state.isAdd=true
    },
    stateValues: (state, action) => {
      state.questionStates[action.payload.name] = action.payload.value
    },
    setEditQuestion: (state, action) => {
      state.questionStates = action.payload
      state.isEdit=action.payload.isEdit
    },
    setSessionQuestion: (state, action) => {
      state.questionStates = action.payload
      state.isSession=action.payload.isSession
    },
    setStatus: (state, action) => {
      state.questionStates.status = action.payload.status
    },
    setAmountState:(state,action) =>{
      state.questionStates.rate_id1 =  action.payload.value
      state.questionStates.rate_id2 = 10 - Number(action.payload.value)
    }
  }
})

// Action creators are generated for each case reducer function
export const { addQuestion, stateRefresh, stateValues, setEditQuestion,setStatus,setAmountState ,setSessionQuestion} = opinionTradingSlice.actions

export default opinionTradingSlice.reducer
